export default import.meta.ROLLUP_FILE_URL_gUk07wQbpU9nQYp_lEOrcQ